import React, { useEffect, useState } from 'react'
import { Button, Input, Modal, Upload } from 'antd'

import { uploadFile } from '../../common/request'
import ResponseCode from '../../common/response-code'

function AppUploadFile ({
  value,
  onChange,
  action = uploadFile,
  accept,
  buttonText = '选择上传',
  placeholder = '请上传文件',
  disabled
}) {
  const [loading, setLoading] = useState(false)
  const [filePath, setFilePath] = useState('')

  useEffect(() => {
    setFilePath(value || '')
  }, [value])

  const beforeUpload = () => {
    setLoading(true)
    return true
  }

  const handleChange = ({ file }) => {
    if (file.status === 'uploading') {
      return
    }

    setLoading(false)

    if (file.status === 'error') {
      Modal.error({
        title: '错误',
        content: '上传失败'
      })
      return
    }

    const res = file.response
    if (!res) {
      return
    }

    if (res.code === ResponseCode.success) {
      const path = res.data?.filePath ?? ''
      setFilePath(path)
      onChange?.(path)
      return
    }

    Modal.error({
      title: '错误',
      content: res.msg || '上传失败'
    })
  }

  const clearFile = () => {
    setFilePath('')
    onChange?.('')
  }

  return (
    <div className="d-flex align-items-center">
      <Input
        className="flex-grow-1"
        value={ filePath }
        placeholder={ placeholder }
        readOnly
        disabled={ disabled }
      />
      <Upload
        name={ 'file' }
        action={ action }
        headers={ {
          authorization: window.sessionStorage.getItem('access_token')
        } }
        disabled={ loading || disabled }
        maxCount={ 1 }
        showUploadList={ false }
        accept={ accept }
        beforeUpload={ beforeUpload }
        onChange={ handleChange }
      >
        <Button
          className="ml-2"
          type={ 'primary' }
          ghost
          loading={ loading }
          disabled={ disabled }
        >{ buttonText }</Button>
      </Upload>
      {
        filePath
          ? (
            <Button
              className="ml-2"
              type={ 'primary' }
              danger
              ghost
              disabled={ disabled }
              onClick={ clearFile }
            >删除</Button>
          )
          : null
      }
    </div>
  )
}

export default AppUploadFile
